import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { callPostWebservice } from './api';
import { appToken, firebaseToken } from '../utils/constants';
import { getFromLocalStorage, saveToLocalStorage } from '../utils/localStorageUtils';
import { printLogs } from '../utils/Utilities';

const useFirebaseTokenUpdate = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tokenUpdateAttemptedRef = useRef(false);
  const previousTokenRef = useRef(null);

  const updateFirebaseTokenInStorage = (currentToken) => {
    if (!currentToken) return;
    
    const savedFirebaseToken = getFromLocalStorage(firebaseToken);
    if (!savedFirebaseToken || savedFirebaseToken !== currentToken) {
      saveToLocalStorage(firebaseToken, currentToken);
      // Reset update attempted flag when token changes
      tokenUpdateAttemptedRef.current = false;
      previousTokenRef.current = currentToken;
      
      // If logged in, update API when token changes
      if (isLoggedIn) {
        updateFirebaseTokenAPI();
      }
    }
  };

  const updateFirebaseTokenAPI = (isLoggin = false) => {
    if (tokenUpdateAttemptedRef.current) return;

    const savedFirebaseToken = getFromLocalStorage(firebaseToken);
    const savedAppToken = getFromLocalStorage(appToken);

    printLogs('Firebase Token Status:', {
      savedFirebaseToken,
      isLoggedIn,
      savedAppToken
    });

    if ((isLoggedIn || isLoggin) && savedAppToken && savedFirebaseToken) {
      tokenUpdateAttemptedRef.current = true;
      
      callPostWebservice('firebase-token', {
        token: savedFirebaseToken,
        column: 'website_token'
      }, (response) => {
        printLogs('Firebase token updated:', response);
      }, null, dispatch, navigate);
    }
  };

  useEffect(() => {
    if (!isLoggedIn) {
      tokenUpdateAttemptedRef.current = false;
    }
  }, [isLoggedIn]);

  return {
    updateFirebaseTokenInStorage,
    updateFirebaseTokenAPI
  };
};

export default useFirebaseTokenUpdate; 